import Head from "next/head";
import Progress from "react-progress";
import Link from "next/link";
import axios from "axios";
import request from 'superagent'

import stylesheet from "../styles/index.scss";
import login from "../styles/login.scss";
import antdStyle from "antd/dist/antd.css";

import _ from "lodash";

import Switcher from "./language-switcher";
import User from "./User";
import Logout from "./Logout";
import Router from 'next/router'

import Layout from "antd/lib/layout";
const { Footer } = Layout;

import { translate } from "react-i18next";
//import {isExpired,AppExplogout} from "../libs/expire"

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: null,
      isExpired:false
    };
  }

  componentDidMount() {
    if (localStorage["token"] != undefined) {
      this.setState({
        token: localStorage["token"],
      });
    }
    this.getTheme();
  }

  async getTheme() {
    const theme = await axios
      .get(`${window.location.origin}/api/v1/theme`)
      .then((result) => result.data);
    localStorage.setItem("theme", JSON.stringify({ ...theme }));

    if(!_.isUndefined(process.env.LICENSE_KEY))
    {
      request
      .get("/api/v1/auth/expire/isexpire")
      .set("Content-Type", "application/json")
      .end(async(err, res) => {
        //console.log(`isExpired = ${res.body.data}`)
        if(res.status == 200)
        {
          if(res.body.data)
            this.setState({isExpired:expired})
        }
      })
    }   
    
  }

  render() {
    const { t } = this.props;
    let status =
      this.state.token != null ? (
        <div className="header-user">
          <Logout />
          <User />
        </div>
      ) : (
        ""
      );

    let favicon = "favicon.png";
    let logo = "logo-go.png";
    // if (process.env.PROJECT == 'GSB') {
    //   logo = 'logo-gsb.png'
    //   favicon = 'favicon-gsb.png'
    // }
    return (
      <div>
        <Head>
          <title>{t(this.props.title)}</title>
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <link
            rel="icon"
            type="image/png"
            href={`/static/images/${favicon}`}
          />
          <style dangerouslySetInnerHTML={{ __html: antdStyle }} />
          <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
          <style dangerouslySetInnerHTML={{ __html: login }} />
        </Head>

        <div className={this.props.class}>
          {[
            "smtb_test",
            "SMTB",
            "GOTEST",
            "PIS",
            "PISGOON",
            "staybridge",
            "TETRAPAK",
            'TETRAPAKUAT'
          ].includes(process.env.PROJECT) && <Switcher />}
          {status}
          <div className={"form-" + this.props.type}>
            <Link href="/">
              <a>
                <img
                  src={`/static/images/${logo}`}
                  className="logo"
                  alt="logo"
                />
              </a>
            </Link>

          <div className={(!_.isUndefined(process.env.LICENSE_KEY) && this.state.isExpired) ? 'wrapper_expire' : 'hidden'}>
            <p style={{marginBottom:20,fontBold:true}}>{t('app_expire.title_expire')}</p>
            <p>{t('app_expire.detail_expired')}</p>
            <p style={{marginTop:20,marginBottom:0}}>{t('app_expire.regard_expire')}</p>
            <p>{t('app_expire.pis_auto_alert_system')}</p>
          </div>

            {this.props.children}
            <Footer className="footer">
              <img
                src={`/static/images/${logo}`}
                className="footer-logo"
                alt="logo"
              />
              {t("copyright")}
            </Footer>
          </div>
        </div>
        <div>
          <Progress
            className="progress"
            color="#1890ff70"
            percent={this.props.progress}
          />
        </div>
      </div>
    );
  }
}

export default translate()(Login);
